export default {
  subscriptionsDetail: null,
};
